import React from 'react';

// Contact Information page - simple, clear ways to reach us
const ContactPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Contact Information</h1>

        <div className="privacy-content">
          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">1</span>
              <h2>Support</h2>
            </div>
            <p>For product or billing help, reach our support team:</p>
            <ul className="terms-list">
              <li>Phone: <a className="terms-link" href="tel:+919652681564">+91 96526 81564</a></li>
              <li>Email: <a className="terms-link" href="mailto:success@getphotoshoot.ai">success@getphotoshoot.ai</a></li>
              <li>Hours: Monday–Friday, 9:00–18:00 IST (excl. holidays)</li>
              <li>Response time: typically within 24 hours</li>
            </ul>
          </section>


          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">2</span>
              <h2>Registered Address</h2>
            </div>
            <p>Qressy Solutions Private Limited</p>
            <p>getphotoshoot.ai</p>
            <p>29-1444/23, Kakathiya Nagar, Near Laxmi Function Hall, Neredmet, Malkajgiri , Hyderabad, Telangana, India - 500056</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;


